const IMG_STATIC_BASE_URL = 'https://imgstatic.phonepe.com/images';

export const Global = Object.freeze({
	MERCHANT_LOGO_BASE_URL: `${IMG_STATIC_BASE_URL}/merchants/200/200/`,
	MERCHANT_LOGO_FALLBACK: `${IMG_STATIC_BASE_URL}/merchants/200/200/M2306160483220675579140.png`,
});
